import Form from '../../helpers/forms/form';

function createBlock() {
    const block = document.createElement('p');
    block.classList.add('form__message');
    return block;
}

function onSuccess(response, instance) {
    const { form } = instance;
    const messages = form.querySelector('.form__messages');
    const block = createBlock(form);

    block.innerText = response.data.message;
    if (response.data.success !== true) {
        messages.classList.add('warning');
        messages.classList.remove('error');
        block.classList.add('warning');
        block.classList.remove('error');
    } else {
        messages.classList.remove('error', 'warning');
        block.classList.add('success');
        block.classList.remove('error', 'warning');
    }

    messages.appendChild(block);
}

function onError(error, instance) {
    const { form } = instance;
    const messages = form.querySelector('.form__messages');
    const block = createBlock(form);

    form.classList.remove('is-successful');
    messages.classList.remove('warning');
    messages.classList.add('error');
    block.classList.remove('warning');
    block.classList.add('error');
    block.innerText = 'Something went wrong, please try again';
    messages.appendChild(block);
}

const options = {
    constraints: {
        // firstName: {
        //     presence: {
        //         allowEmpty: false,
        //     },
        // },
        // surname: {
        //     presence: {
        //         allowEmpty: false,
        //     },
        // },

        email: {
            presence: {
                allowEmpty: false,
            },
            email: true,
        },
    },
    selectors: {
        inputGroup: '.form__group',
        label: '[data-label]',
    },
    form: {
        onValid: (form, instance) => { },
    },
    input: {
        onValid: (input, instance) => { },
        onError: (input, error, instance) => { },
    },
    request: {
        type: 'post',
        url: example_ajax_obj.ajaxurl,
        success: (response, instance) => {
            onSuccess(response, instance);
        },
        error: (error, instance) => {
            onError(error, instance);
        },
        submitDelay: 300,
    },
};

export function initNewsletterForm() {
    const form = document.querySelector('.form.form--newsletter.js-validate');

    if (form !== null) {
        new Form(form, options);
    }
}

